var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.625 13.83C30.4394 13.5727 30.1952 13.3632 29.9127 13.2189C29.6301 13.0746 29.3173 12.9995 29 13H27V11C27 10.4696 26.7893 9.96086 26.4142 9.58579C26.0391 9.21071 25.5304 9 25 9H16.3337L12.8675 6.4C12.5207 6.14148 12.1 6.00125 11.6675 6H5C4.46957 6 3.96086 6.21071 3.58579 6.58579C3.21071 6.96086 3 7.46957 3 8V26C3 26.2652 3.10536 26.5196 3.29289 26.7071C3.48043 26.8946 3.73478 27 4 27H26.3875C26.5974 27 26.802 26.934 26.9722 26.8113C27.1425 26.6886 27.2699 26.5154 27.3363 26.3162L30.8975 15.6325C30.9976 15.3319 31.0252 15.0118 30.9778 14.6985C30.9304 14.3852 30.8095 14.0876 30.625 13.83ZM11.6675 8L15.4 10.8C15.5731 10.9298 15.7836 11 16 11H25V13H8.72125C8.30147 13 7.89232 13.132 7.55176 13.3775C7.2112 13.6229 6.95651 13.9693 6.82375 14.3675L5 19.8375V8H11.6675ZM25.6675 25H5.3875L8.72125 15H29L25.6675 25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOpen);
export default __webpack_public_path__ + "static/media/folder-open.88adfe5fbc61733df6bdce1edf0c10f5.svg";
export { ForwardRef as ReactComponent };